export default "__VITE_ASSET__YXFIIVOq__"